import {
  Injectable,
} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RedirectCommand,
  Router,
} from '@angular/router';
import {
  select,
  Store,
} from '@ngrx/store';
import {
  getParamInRoute,
} from '@refx/shared-common';
import {
  CatalogServicesStore,
  selectSelectedCategoryCode,
  UpdateCatalogServices,
} from '@refx/shared-store';
import {
  combineLatest,
  Observable,
} from 'rxjs';
import {
  map,
  take,
} from 'rxjs/operators';
import {
  SsciRouteParams,
  SsciRoutes,
} from '../../configuration/routes';

@Injectable()
export class AddServiceCodeParamGuard implements CanActivate {
  constructor(private readonly router: Router, private readonly store: Store<CatalogServicesStore>) {}

  /**
   * Add service code as query param in the URL if not present
   *
   * @param route the active route snapshot
   */
  public canActivate(route: ActivatedRouteSnapshot): boolean | Observable<boolean | RedirectCommand> {
    const serviceCode = getParamInRoute(SsciRouteParams.serviceCode, route);

    if (serviceCode) {
      this.store.dispatch(UpdateCatalogServices({
        selectedCategoryCode: serviceCode
      }));
      return true;
    }

    return combineLatest([
      this.store.pipe(
        select(selectSelectedCategoryCode),
        take(1)
      )
    ]).pipe(
      map(([categoryCode]: [string]) => {
        return categoryCode
          ? new RedirectCommand(this.router.createUrlTree([...route.url.map((segment) => segment.path), categoryCode]), {
            replaceUrl: false
          })
          : new RedirectCommand(this.router.parseUrl(SsciRoutes.overview), {
            replaceUrl: false
          });
      })
    );
  }
}
